import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { VyuTheme } from '../theme/types'
import { createTheme } from '../theme/defaultTheme'

const initialState: VyuTheme = createTheme()

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<VyuTheme>) => {
      const { name, colors, images, fonts, messages } = action.payload
      state.name = name
      state.messages = messages
      state.colors = colors
      state.fonts = fonts
      state.images = images
    },
  },
})

export const { setTheme } = themeSlice.actions

export default themeSlice.reducer
